import { Alert } from '@statsbomb/kitbag-components';
import React from 'react';
import { useTranslation } from 'react-i18next';

export const UnavailableVideosMessage = ({ unavailableVideosCount }: { unavailableVideosCount?: number }) => {
  const { t } = useTranslation('video');

  return (
    !!unavailableVideosCount && (
      <div className="pt-4">
        <Alert isFullWidth type="info">
          {t('noLicenceCount', { count: unavailableVideosCount })}
        </Alert>
      </div>
    )
  );
};
